module.exports = __webpack_public_path__ + "pattern5.012acbe788ee429da8d7.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/pattern5.png
// module id = ../../../../../src/img/pattern5.png
// module chunks = styles